var map = {
	"./ambulancia.png": 6849,
	"./aviao.png": 3966,
	"./balao.png": 4965,
	"./barco-de-resgate.png": 4169,
	"./barco-escolar.png": 2285,
	"./barco.png": 1461,
	"./bomba.png": 5309,
	"./caminhao.png": 770,
	"./caminhonete.png": 5761,
	"./carro-de-bombeiros.png": 4218,
	"./carro-de-policia.png": 6519,
	"./carro-eletrico.png": 2191,
	"./carro.png": 155,
	"./generico.png": 7852,
	"./helicoptero.png": 6490,
	"./live-green-car.png": 399,
	"./maquinario.png": 1786,
	"./micro-onibus.png": 4985,
	"./moto.png": 3001,
	"./motoneta.png": 955,
	"./onibus-escolar.png": 8612,
	"./onibus.png": 7180,
	"./reboque.png": 5537,
	"./reservatorio.png": 7997,
	"./retro-escavadeira.png": 7799,
	"./trator.png": 9528,
	"./utilitario.png": 3664,
	"./van.png": 2515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9717;